(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[40],{

/***/ "0HFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/carousel-container/styles.module.scss
var styles_module = __webpack_require__("SVo4");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// EXTERNAL MODULE: ./src/components/e6t/lazy-image/index.jsx
var lazy_image = __webpack_require__("eM4/");

// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/carousel-item/styles.module.scss
var carousel_item_styles_module = __webpack_require__("ayqK");
var carousel_item_styles_module_default = /*#__PURE__*/__webpack_require__.n(carousel_item_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/carousel-item/index.jsx
var __jsx = react_default.a.createElement;




var carousel_item_CarouselItem = function CarouselItem(_ref) {
  var item = _ref.item,
      prev = _ref.prev,
      next = _ref.next,
      isLazy = _ref.isLazy;
  return __jsx(react_default.a.Fragment, null, isLazy ? __jsx(lazy_image["a" /* default */], {
    src: item,
    alt: item
  }) : __jsx("img", {
    src: item,
    alt: item
  }), __jsx("div", {
    onClick: function onClick() {
      prev();
    },
    className: carousel_item_styles_module_default.a.prevContainer
  }), __jsx("div", {
    onClick: function onClick() {
      next();
    },
    className: carousel_item_styles_module_default.a.nextContainer
  }));
};

/* harmony default export */ var carousel_item = (carousel_item_CarouselItem);
// EXTERNAL MODULE: ./src/components/desktop/google-publisher-tags/gpt-ad-element/index.js
var gpt_ad_element = __webpack_require__("KLAI");

// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/gptAd-container/styles.module.scss
var gptAd_container_styles_module = __webpack_require__("xhFV");
var gptAd_container_styles_module_default = /*#__PURE__*/__webpack_require__.n(gptAd_container_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/gptAd-container/index.jsx
var gptAd_container_jsx = react_default.a.createElement;




var gptAd_container_GptAdContainer = function GptAdContainer(_ref) {
  var prev = _ref.prev,
      next = _ref.next;
  react_default.a.useEffect(function () {
    var _document$getElementB, _document$getElementB2, _document$getElementB3;

    var link = document.getElementById('google_ads_iframe_/21155722/emlakjet_web/ej_w_galeri_0') ? (_document$getElementB = document.getElementById('google_ads_iframe_/21155722/emlakjet_web/ej_w_galeri_0')) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.contentWindow) === null || _document$getElementB2 === void 0 ? void 0 : (_document$getElementB3 = _document$getElementB2.document.getElementById('aw0')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.href : '#';
    document.getElementById('ad-link').href = link;
  });
  return gptAd_container_jsx("div", {
    style: {
      maxWidth: 921,
      maxHeight: 497,
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative'
    }
  }, gptAd_container_jsx("a", {
    id: "ad-link",
    target: "_blank",
    style: {
      position: 'absolute',
      width: '235px',
      height: '50px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: 30,
      right: 30,
      backgroundColor: '#fff',
      zIndex: 99,
      color: '#000',
      fontSize: 15,
      textDecoration: 'none',
      fontWeight: 400,
      opacity: 0
    }
  }, "\u0130ncele"), gptAd_container_jsx("div", {
    onClick: function onClick() {
      prev();
    },
    className: gptAd_container_styles_module_default.a.prevContainer
  }), gptAd_container_jsx("div", {
    onClick: function onClick() {
      next();
    },
    className: gptAd_container_styles_module_default.a.nextContainer
  }));
};

/* harmony default export */ var gptAd_container = (gptAd_container_GptAdContainer);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/carousel-arrow/styles.module.scss
var carousel_arrow_styles_module = __webpack_require__("93nn");
var carousel_arrow_styles_module_default = /*#__PURE__*/__webpack_require__.n(carousel_arrow_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/carousel-arrow/index.jsx

var carousel_arrow_jsx = react_default.a.createElement;




var iconStyle = {
  fontSize: 36,
  userSelect: 'none',
  color: '#ffffff'
};

var carousel_arrow_SliderArrow = function SliderArrow(_ref) {
  var _className;

  var prev = _ref.prev,
      next = _ref.next,
      onClick = _ref.onClick,
      white = _ref.white;
  var classnames = classnames_default()((_className = {}, Object(defineProperty["default"])(_className, carousel_arrow_styles_module_default.a.arrow, true), Object(defineProperty["default"])(_className, carousel_arrow_styles_module_default.a.prev, prev), Object(defineProperty["default"])(_className, carousel_arrow_styles_module_default.a.next, next), Object(defineProperty["default"])(_className, carousel_arrow_styles_module_default.a.white, white), _className));
  var iconName = prev ? 'chevron_left' : 'chevron_right';
  var dataLabel = prev ? 'link_previousphoto' : 'link_nextphoto';
  var dataAction = white ? 'expandedphoto' : 'photobox';
  return carousel_arrow_jsx("div", {
    className: classnames,
    onClick: onClick,
    "data-ej-category": "detailpage",
    "data-ej-action": dataAction,
    "data-ej-label": dataLabel
  }, carousel_arrow_jsx(desktop_elements["e" /* Icon */], {
    name: iconName,
    style: iconStyle,
    "data-ej-category": "detailpage",
    "data-ej-action": dataAction,
    "data-ej-label": dataLabel
  }));
};

/* harmony default export */ var carousel_arrow = (carousel_arrow_SliderArrow);
// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/carousel-index/styles.module.scss
var carousel_index_styles_module = __webpack_require__("tV6b");
var carousel_index_styles_module_default = /*#__PURE__*/__webpack_require__.n(carousel_index_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/carousel-index/index.jsx
var carousel_index_jsx = react_default.a.createElement;




var carousel_index_ImageIndex = function ImageIndex(_ref) {
  var active = _ref.active,
      count = _ref.count,
      isLazy = _ref.isLazy;
  return carousel_index_jsx("div", {
    className: carousel_index_styles_module_default.a.showIndex
  }, isLazy ? carousel_index_jsx(lazy_image["a" /* default */], {
    src: "/static/icons/image-group.svg",
    alt: "imagegroup icon"
  }) : carousel_index_jsx("img", {
    src: "/static/icons/image-group.svg",
    alt: "imagegroup icon"
  }), carousel_index_jsx("span", null, "".concat(active + 1, " / ").concat(count)));
};

/* harmony default export */ var carousel_index = (carousel_index_ImageIndex);
// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/oda-studio-full-screen/index.jsx
var oda_studio_full_screen = __webpack_require__("bigh");

// EXTERNAL MODULE: ./src/components/e6t/desktop/tooltip/index.jsx
var tooltip = __webpack_require__("MbeT");

// EXTERNAL MODULE: ./src/components/desktop/oda-studio-modal/index.jsx
var oda_studio_modal = __webpack_require__("UCP0");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events.js
var events = __webpack_require__("tkT3");

// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/oda-studio/styles.module.scss
var oda_studio_styles_module = __webpack_require__("Bk2y");
var oda_studio_styles_module_default = /*#__PURE__*/__webpack_require__.n(oda_studio_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/oda-studio/index.jsx
var oda_studio_jsx = react_default.a.createElement;






var oda_studio_OdaStudio = function OdaStudio(_ref) {
  var decorator = _ref.decorator;

  var _useState = Object(react["useState"])(false),
      openIframe = _useState[0],
      setIsOpenIframe = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      openTooltip = _useState2[0],
      setOpenTooltip = _useState2[1];

  var onClickIframe = function onClickIframe() {
    setIsOpenIframe(!openIframe);
    !openIframe && Object(events["o" /* formGTMEventGA4 */])({
      eventName: 'evini_tasarla',
      eventParameters: {
        label: 'view-popup-odastudio-detay'
      }
    });
  };

  Object(react["useEffect"])(function () {
    var _document;

    setTimeout(function () {
      setOpenTooltip(false);
    }, 3000);
    var element = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById('toolTip');
    element.addEventListener('mouseover', function () {
      setOpenTooltip(true);
    });
    element.addEventListener('mouseleave', function () {
      setOpenTooltip(false);
    });
  }, []);
  return oda_studio_jsx("div", {
    className: oda_studio_styles_module_default.a.container
  }, oda_studio_jsx(tooltip["a" /* default */], {
    open: openTooltip,
    placement: "bottom-start",
    classes: {
      title: oda_studio_styles_module_default.a.tooltipTitle,
      arrow: oda_studio_styles_module_default.a.arrowTooltip,
      bootstrapTooltip: oda_studio_styles_module_default.a.containerTooltip
    },
    title: "Bu evin yapay zeka ile dekore edilmi\u015F halini incelemek ister misin?"
  }, oda_studio_jsx("div", {
    id: "toolTip",
    className: oda_studio_styles_module_default.a.toolTipWrapper,
    onClick: onClickIframe
  }, oda_studio_jsx("img", {
    className: oda_studio_styles_module_default.a.toolTipWrapperIcon,
    src: "/static/icons/oda-studio-web.svg",
    alt: "oda-studio-web.svg"
  }), oda_studio_jsx("span", {
    className: oda_studio_styles_module_default.a.toolTipWrapperText
  }, "Evini Tasarla"))), oda_studio_jsx("div", null, oda_studio_jsx(oda_studio_modal["a" /* default */], {
    boardUrl: decorator === null || decorator === void 0 ? void 0 : decorator.boardUrl,
    openIframe: openIframe,
    onClickIframe: onClickIframe
  })));
};

/* harmony default export */ var oda_studio = (oda_studio_OdaStudio);
// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/carousel-container/index.jsx

var carousel_container_jsx = react_default.a.createElement;









var carousel_container_CarouselContainer = function CarouselContainer(_ref) {
  var carouselItems = _ref.carouselItems,
      currentIndex = _ref.currentIndex,
      prev = _ref.prev,
      next = _ref.next,
      fullscreen = _ref.fullscreen,
      style = _ref.style,
      isShortHeight = _ref.isShortHeight,
      decorator = _ref.decorator,
      isLazy = _ref.isLazy;
  var currentIndexRef = react_default.a.useRef(null);

  var _React$useState = react_default.a.useState(null),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      translateValue = _React$useState2[0],
      setTranslateValue = _React$useState2[1];

  react_default.a.useEffect(function () {
    setTranslateValue(currentIndex * -currentIndexRef.current.clientWidth);
  });
  return carousel_container_jsx("div", {
    className: styles_module_default.a.carousel,
    style: style
  }, carousel_container_jsx("div", {
    className: styles_module_default.a.carouselItemWrapper,
    style: {
      transform: "translateX(".concat(translateValue, "px)")
    },
    ref: currentIndexRef
  }, carouselItems.map(function (item) {
    return carousel_container_jsx("div", {
      className: styles_module_default.a.image,
      "data-type": "image",
      key: item,
      style: isShortHeight ? {
        height: 'calc(100% - 90px)'
      } : {}
    }, carousel_container_jsx(carousel_item, {
      item: item,
      prev: prev,
      next: next,
      isLazy: isLazy
    }));
  }), carousel_container_jsx("div", {
    className: styles_module_default.a.image,
    style: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'transparent'
    },
    id: "ads",
    "data-type": "ads"
  }, carousel_container_jsx(gptAd_container, {
    prev: prev,
    next: next
  }))), carousel_container_jsx(carousel_arrow, {
    prev: true,
    onClick: prev,
    white: fullscreen
  }), carousel_container_jsx(carousel_arrow, {
    next: true,
    onClick: next,
    white: fullscreen
  }), currentIndex !== carouselItems.length ? carousel_container_jsx(carousel_index, {
    active: currentIndex,
    count: carouselItems.length,
    isLazy: isLazy
  }) : null);
};

/* harmony default export */ var carousel_container = __webpack_exports__["a"] = (carousel_container_CarouselContainer);

/***/ }),

/***/ "4O0V":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"_2f0fma","iconWrapper":"_3JlZob","closeWrapper":"_1VRxhx","odaStudioWrapper":"_6ptXS3","odaStudioIcon":"_3Wvo72","odaStudioText":"_3KEjmo"};

/***/ }),

/***/ "5Fhy":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"_1S0HQZ","videoContainer":"_3KH7uU"};

/***/ }),

/***/ "66bh":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"_14QeHB","leftOuter":"_2sCpiD","left":"_3N4ixH","rightOuter":"_1ek9p3","meterPrice":"_2A20N3","right":"_3P3Iyf"};

/***/ }),

/***/ "8AuA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ODXe");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SUMQ");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("0G56");
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_AppBar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("YDiY");
/* harmony import */ var _material_ui_core_AppBar__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_AppBar__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_Tabs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TIln");
/* harmony import */ var _material_ui_core_Tabs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Tabs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("gktk");
/* harmony import */ var _material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_carousel_container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("0HFM");
/* harmony import */ var _components_thumbnails_container__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("yCkj");
/* harmony import */ var _components_header__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("SzNQ");
/* harmony import */ var _helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tkT3");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5Fhy");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _components_oda_studio_full_screen__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("bigh");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;













var tabStyles = function tabStyles() {
  return {
    root: {
      backgroundColor: '#172530',
      borderTop: '1px solid rgba(255, 255, 255, 0.15)'
    },
    tab: {
      color: '#fff'
    }
  };
};

var logger = false;

var log = function log(message) {
  if (logger) {
    console.log('fullscreen =>', message);
  }
};

var Fullscreen = function Fullscreen(_ref) {
  var images = _ref.images,
      thumbnails = _ref.thumbnails,
      currentIndex = _ref.currentIndex,
      fullscreen = _ref.fullscreen,
      toggleFullScreen = _ref.toggleFullScreen,
      prevSlide = _ref.prevSlide,
      nextSlide = _ref.nextSlide,
      listing = _ref.listing,
      thumbnailsVisibleCount = _ref.thumbnailsVisibleCount,
      changeCurrentIndex = _ref.changeCurrentIndex,
      children = _ref.children,
      isShortHeight = _ref.isShortHeight,
      classes = _ref.classes,
      _ref$videoUrl = _ref.videoUrl,
      videoUrl = _ref$videoUrl === void 0 ? null : _ref$videoUrl,
      isYoutubeVideo = _ref.isYoutubeVideo,
      decorator = _ref.decorator,
      isLazy = _ref.isLazy;
  var FullscreenThumbnailsRef = react__WEBPACK_IMPORTED_MODULE_1___default.a.useRef(null);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1___default.a.useState(images),
      _React$useState2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_React$useState, 2),
      carouselItems = _React$useState2[0],
      setCarouselItems = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_1___default.a.useState(carouselItems.length),
      _React$useState4 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_React$useState3, 2),
      sliderCount = _React$useState4[0],
      setSliderCount = _React$useState4[1];

  var _React$useState5 = react__WEBPACK_IMPORTED_MODULE_1___default.a.useState(0),
      _React$useState6 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_React$useState5, 2),
      activeTabIndex = _React$useState6[0],
      setActiveTabIndex = _React$useState6[1];

  var indicatorCount = Math.ceil(sliderCount / thumbnailsVisibleCount);

  var _React$useState7 = react__WEBPACK_IMPORTED_MODULE_1___default.a.useState(Math.floor(currentIndex / thumbnailsVisibleCount)),
      _React$useState8 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_React$useState7, 2),
      activeIndicator = _React$useState8[0],
      setIndicator = _React$useState8[1];

  var usePrevious = function usePrevious(value) {
    var ref = react__WEBPACK_IMPORTED_MODULE_1___default.a.useRef();
    react__WEBPACK_IMPORTED_MODULE_1___default.a.useEffect(function () {
      ref.current = value;
    });
    return ref.current;
  };

  var prevProps = usePrevious({
    fullscreen: fullscreen
  });
  react__WEBPACK_IMPORTED_MODULE_1___default.a.useEffect(function () {
    if (prevProps && prevProps !== fullscreen) {
      var currentIndicator = Math.floor(currentIndex / thumbnailsVisibleCount);
      setIndicator(currentIndicator);
      setActiveTabIndex(0);
    }
  }, [fullscreen]);

  var thumbnailsScrollLeft = function thumbnailsScrollLeft() {
    if (activeIndicator !== 0) {
      FullscreenThumbnailsRef.current.scrollLeft -= FullscreenThumbnailsRef.current.clientWidth;
      setIndicator(activeIndicator - 1);
      return;
    }

    FullscreenThumbnailsRef.current.scrollLeft += (indicatorCount - 1) * FullscreenThumbnailsRef.current.clientWidth;
    setIndicator(indicatorCount - 1);
  };

  var thumbnailsScrollRight = function thumbnailsScrollRight() {
    if (activeIndicator !== indicatorCount - 1) {
      FullscreenThumbnailsRef.current.scrollLeft += FullscreenThumbnailsRef.current.clientWidth;
      setIndicator(activeIndicator + 1);
    } else {
      FullscreenThumbnailsRef.current.scrollLeft -= (indicatorCount - 1) * FullscreenThumbnailsRef.current.clientWidth;
      setIndicator(0);
    }
  };

  var prev = function prev() {
    Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_10__[/* galleryGTMEvent */ "q"])({
      action: 'tam-ekran',
      label: 'onceki'
    });
    Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_10__[/* formGTMEventGA4 */ "o"])({
      eventName: 'click_button',
      eventParameters: {
        label: "galeri||prev"
      }
    });
    prevSlide(currentIndex, sliderCount, function (index) {
      var currentIndicator = Math.floor(index / thumbnailsVisibleCount);

      if (currentIndicator !== activeIndicator) {
        thumbnailsScrollLeft();
      }

      setIndicator(currentIndicator);
    });
  };

  var next = function next() {
    Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_10__[/* galleryGTMEvent */ "q"])({
      action: 'tam-ekran',
      label: 'sonraki'
    });
    Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_10__[/* formGTMEventGA4 */ "o"])({
      eventName: 'click_button',
      eventParameters: {
        label: "galeri||next"
      }
    });
    nextSlide(currentIndex, sliderCount, function (index) {
      var currentIndicator = Math.floor(index / thumbnailsVisibleCount);

      if (currentIndicator !== activeIndicator) {
        thumbnailsScrollRight();
      }

      setIndicator(currentIndicator);
    });
  };

  var handleTabChange = function handleTabChange(event, value) {
    setActiveTabIndex(value);
  };

  return __jsx(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_3___default.a, {
    fullScreen: true,
    open: fullscreen,
    onClose: toggleFullScreen
  }, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default.a.fullscreen
  }, children || (listing ? __jsx(_components_header__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"], {
    listing: listing,
    close: toggleFullScreen,
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    gtmEventLabel: "galeri"
  }) : __jsx(_components_header__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"], {
    listing: null,
    close: toggleFullScreen,
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  })), __jsx(_material_ui_core_AppBar__WEBPACK_IMPORTED_MODULE_4___default.a, {
    position: "static"
  }, __jsx(_material_ui_core_Tabs__WEBPACK_IMPORTED_MODULE_5___default.a, {
    className: classes.root,
    value: activeTabIndex,
    onChange: handleTabChange,
    indicatorColor: "primary",
    textColor: "primary"
  }, __jsx(_material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6___default.a, {
    className: classes.tab,
    label: "Foto\u011Fraflar"
  }), videoUrl && __jsx(_material_ui_core_Tab__WEBPACK_IMPORTED_MODULE_6___default.a, {
    className: classes.tab,
    label: "Video"
  }))), activeTabIndex === 0 && __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx(_components_carousel_container__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], {
    fullscreen: fullscreen,
    currentIndex: currentIndex,
    carouselItems: carouselItems,
    prev: prev,
    next: next // style={{ height: '74%' }}
    ,
    isShortHeight: isShortHeight,
    decorator: decorator,
    isLazy: isLazy
  }), __jsx(_components_thumbnails_container__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], {
    fullscreen: fullscreen,
    thumbnails: thumbnails,
    thumbnailsRef: FullscreenThumbnailsRef,
    thumbnailsScrollLeft: thumbnailsScrollLeft,
    thumbnailsScrollRight: thumbnailsScrollRight,
    thumbnailsVisibleCount: thumbnailsVisibleCount,
    currentIndex: currentIndex,
    carouselItems: carouselItems,
    activeIndicator: activeIndicator,
    indicatorCount: indicatorCount,
    changeCurrentIndex: changeCurrentIndex
  })), activeTabIndex === 1 && videoUrl && __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default.a.videoContainer
  }, isYoutubeVideo ? __jsx("iframe", {
    src: videoUrl === null || videoUrl === void 0 ? void 0 : videoUrl.split("&")[0],
    title: videoUrl,
    height: "100%",
    width: "100%",
    allowFullScreen: true,
    frameBorder: "0"
  }) : // eslint-disable-next-line jsx-a11y/media-has-caption
  __jsx("video", {
    src: videoUrl,
    title: listing === null || listing === void 0 ? void 0 : listing.title,
    controls: true,
    height: "100%",
    width: "100%"
  }))));
};

/* harmony default export */ __webpack_exports__["a"] = (Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__["withStyles"])(tabStyles)(Fullscreen));

/***/ }),

/***/ "93nn":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_2OtYQ9","prev":"_307-Z_","next":"_2pUXNK","white":"_2nyPyx"};

/***/ }),

/***/ "9Rzt":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_1XC-IY","prev":"_8zdw4A","next":"_6PhSON","fullscreen":"_2wuoxv"};

/***/ }),

/***/ "9wM+":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"price":"_2TxNQv","isFullPage":"_15axmz","priceActions":"ukxyhf","priceTrend":"_2yCPH5","priceBand":"OqBSwC","meterPrice":"_10zOt7","fullpageMeterPrice":"_13YS1V"};

/***/ }),

/***/ "Bk2y":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1M_9MC","toolTipWrapper":"opjktp","toolTipWrapperIcon":"eQ1G8X","toolTipWrapperText":"_3HGjof","tooltipTitle":"lE3kGn","containerTooltip":"_9TyWVE","arrowTooltip":"xg-nkg"};

/***/ }),

/***/ "Fxm3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var throttle = function throttle(fn) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var last;
  var timer;
  return function () {
    var now = +new Date();
    var timePassed = !!last && now < last + threshold;

    if (timePassed) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn();
      }, threshold);
    } else {
      last = now;
      fn();
    }
  };
};

var _default = throttle;
exports.default = _default;

/***/ }),

/***/ "SVo4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_1pzXKZ","carouselItemWrapper":"_32UR5Z","image":"_1L9i7q","prevContainer":"_2Izobn","nextContainer":"_30vm69"};

/***/ }),

/***/ "SzNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/desktop/common/logo/index.jsx
var logo = __webpack_require__("DQ2z");

// EXTERNAL MODULE: ./src/components/desktop/listing-detail/listing-detail-owner-widget/show-phone/index.jsx
var show_phone = __webpack_require__("+vld");

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/desktop/listing-detail/listing-detail-price/index.jsx
var listing_detail_price = __webpack_require__("Tl41");

// EXTERNAL MODULE: ./src/components/desktop/elements/breadcrumb-e6t/index.jsx
var breadcrumb_e6t = __webpack_require__("fXCu");

// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/header/title/styles.module.scss
var styles_module = __webpack_require__("tskV");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/header/title/index.jsx
var __jsx = react_default.a.createElement;




var title_Title = function Title(_ref) {
  var listing = _ref.listing;
  return __jsx("div", {
    className: styles_module_default.a.content
  }, __jsx("h1", {
    className: styles_module_default.a.h1
  }, listing.title), __jsx(breadcrumb_e6t["a" /* default */], {
    crumbs: listing.breadcrumbs
  }));
};

/* harmony default export */ var title = (title_Title);
// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/header/styles.module.scss
var header_styles_module = __webpack_require__("66bh");
var header_styles_module_default = /*#__PURE__*/__webpack_require__.n(header_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/header/index.jsx
var header_jsx = react_default.a.createElement;








var header_FullImageHeader = function FullImageHeader(_ref) {
  var _listing$owner, _listing$owner$accoun;

  var listing = _ref.listing,
      close = _ref.close,
      style = _ref.style,
      gtmEventLabel = _ref.gtmEventLabel;
  return header_jsx("div", {
    className: header_styles_module_default.a.headerContainer,
    style: style
  }, listing ? header_jsx(react_default.a.Fragment, null, header_jsx("div", {
    className: header_styles_module_default.a.leftOuter
  }, header_jsx("div", {
    className: header_styles_module_default.a.left
  }, header_jsx(logo["a" /* default */], {
    single: true,
    style: {
      marginLeft: 16,
      height: 40
    }
  }), header_jsx(title, {
    listing: listing
  }))), header_jsx("div", {
    className: header_styles_module_default.a.rightOuter
  }, header_jsx("div", {
    className: header_styles_module_default.a.right
  }, header_jsx(listing_detail_price["a" /* default */], {
    listing: listing,
    fullPage: true
  }), header_jsx("div", {
    style: {
      marginRight: '16px',
      marginLeft: '16px'
    }
  }, header_jsx(show_phone["a" /* default */], {
    isSmall: true,
    listingOwnerPhone: (_listing$owner = listing.owner) === null || _listing$owner === void 0 ? void 0 : (_listing$owner$accoun = _listing$owner.account) === null || _listing$owner$accoun === void 0 ? void 0 : _listing$owner$accoun.phoneNumber,
    clearPhoneNumber: true,
    listingId: listing.id,
    price: listing.priceDetail,
    gtmEventLabel: gtmEventLabel,
    listing: listing
  })), header_jsx(desktop_elements["b" /* Button */], {
    transparent: true,
    onClick: close,
    style: {
      marginRight: '16px'
    }
  }, header_jsx(desktop_elements["e" /* Icon */], {
    name: "close",
    style: {
      color: '#fff'
    }
  }), header_jsx("p", {
    style: {
      color: '#fff',
      fontSize: '14px',
      fontWeight: 500
    }
  }, "Kapat"))))) : header_jsx(desktop_elements["b" /* Button */], {
    transparent: true,
    onClick: close,
    style: {
      marginRight: '16px'
    }
  }, header_jsx(desktop_elements["e" /* Icon */], {
    name: "close",
    style: {
      color: '#fff'
    }
  }), header_jsx("p", {
    style: {
      color: '#fff',
      fontSize: '14px',
      fontWeight: 500
    }
  }, "Kapat")));
};

/* harmony default export */ var header = __webpack_exports__["a"] = (header_FullImageHeader);

/***/ }),

/***/ "Tl41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("tkT3");
/* harmony import */ var _utils_number_formatter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("BF7R");
/* harmony import */ var _utils_number_formatter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_utils_number_formatter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _elements__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9aJQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("9wM+");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var ListingDetailPrice = function ListingDetailPrice(_ref) {
  var _listing$properties, _listing$properties2, _classNames, _classNames2;

  var listing = _ref.listing,
      scrollOffset = _ref.scrollOffset,
      fullPage = _ref.fullPage;
  var price = listing.priceDetail;
  if (!listing || !price) return null;
  var infoProperty = (_listing$properties = listing.properties) === null || _listing$properties === void 0 ? void 0 : _listing$properties.map(function (property) {
    return property;
  });
  var infoPropertyCategory = (_listing$properties2 = listing.properties) === null || _listing$properties2 === void 0 ? void 0 : _listing$properties2.find(function (property) {
    return property.key === 'category';
  });
  var visiblePrice = price.price == null ? price.alternativeValue : _utils_number_formatter__WEBPACK_IMPORTED_MODULE_3___default.a.format(price.price);
  var visiblePriceCurrency = price.price == null ? '' : price.currency;
  var isDownTrend = price.trendType === 'down';
  var pricePercent = price === null || price === void 0 ? void 0 : price.differenceRate;
  var meterPrice = price === null || price === void 0 ? void 0 : price.squareMeterPrice;
  var priceContainer = classnames__WEBPACK_IMPORTED_MODULE_5___default()((_classNames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default.a.price, true), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default.a.isFullPage, fullPage), _classNames));
  var meterPriceStyle = classnames__WEBPACK_IMPORTED_MODULE_5___default()((_classNames2 = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames2, _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default.a.meterPrice, true), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames2, _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default.a.fullpageMeterPrice, fullPage), _classNames2));

  var handleClick = function handleClick(e) {
    var scrollItem = e.target.dataset.scroll;

    if (isDownTrend) {
      Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_2__[/* listingPriceDownEvents */ "A"])({
        label: 'detay'
      });
    }

    if (scrollItem) {
      window.scrollTo({
        top: document.getElementById(scrollItem).offsetTop - scrollOffset,
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  return __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx("div", {
    className: priceContainer
  }, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default.a.priceBand,
    "data-scroll": "fiyat-analizi",
    onClick: handleClick
  }), visiblePrice, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default.a.priceActions
  }, visiblePriceCurrency, isDownTrend && pricePercent > 0 && __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default.a.priceTrend
  }, __jsx(_elements__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "e"], {
    name: "arrow_downward"
  }), __jsx("span", null, "%".concat(pricePercent))))), (infoPropertyCategory === null || infoPropertyCategory === void 0 ? void 0 : infoPropertyCategory.value) === 'Arsa' && (infoProperty === null || infoProperty === void 0 ? void 0 : infoProperty.map(function (property) {
    return property.key === 'square_meter_price' && __jsx("div", {
      className: meterPriceStyle
    }, meterPrice !== '0' && "".concat(_utils_number_formatter__WEBPACK_IMPORTED_MODULE_3___default.a.format(meterPrice), " TL/m\xB2"));
  })));
};

ListingDetailPrice.defaultProps = {
  fullPage: false
};
/* harmony default export */ __webpack_exports__["a"] = (ListingDetailPrice);

/***/ }),

/***/ "TyMc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"nR8QkL","odaStudioWrapper":"Z5095T","odaStudioWrapperIcon":"_2gwsx5","odaStudioWrapperText":"fzOBjG","odaStudioWrapperReviewText":"_WfNZV"};

/***/ }),

/***/ "UCP0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9aJQ");
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hzb6");
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("tkT3");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("4O0V");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var OdaStudioModal = function OdaStudioModal(_ref) {
  var boardUrl = _ref.boardUrl,
      openIframe = _ref.openIframe,
      onClickIframe = _ref.onClickIframe;

  var listener = function listener(event) {
    if (event.origin.indexOf('odastudio.ai') > 0) {
      var eventData = event === null || event === void 0 ? void 0 : event.data;

      if (eventData === null || eventData === void 0 ? void 0 : eventData.type) {
        if ((eventData === null || eventData === void 0 ? void 0 : eventData.type) === 'shareClicked') {
          var _eventData$properties;

          eventData.properties = {
            method: eventData === null || eventData === void 0 ? void 0 : (_eventData$properties = eventData.properties) === null || _eventData$properties === void 0 ? void 0 : _eventData$properties.platform
          };
        }

        Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_4__[/* formGTMEventGA4 */ "o"])({
          eventName: 'evini_tasarla',
          eventParameters: _objectSpread({
            label: eventData === null || eventData === void 0 ? void 0 : eventData.type
          }, eventData === null || eventData === void 0 ? void 0 : eventData.properties)
        });
      }
    }
  };

  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    if (openIframe) {
      window.addEventListener('message', listener);
    }

    return function () {
      window.removeEventListener('message', listener);
    };
  }, [openIframe]);
  return __jsx("div", null, __jsx(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3___default.a, {
    open: openIframe,
    onClose: onClickIframe
  }, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.modalContainer
  }, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.iconWrapper
  }, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.odaStudioWrapper
  }, __jsx("img", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.odaStudioIcon,
    src: "/static/icons/oda-studio-web-black.svg",
    alt: "oda-studio-web.svg"
  }), __jsx("span", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.odaStudioText
  }, "Evini Tasarla")), __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.closeWrapper,
    onClick: onClickIframe
  }, __jsx(_elements__WEBPACK_IMPORTED_MODULE_2__[/* Icon */ "e"], {
    name: "close"
  }), __jsx("span", null, "Kapat"))), __jsx("iframe", {
    src: boardUrl,
    title: boardUrl,
    height: "100%",
    width: "100%",
    allowFullScreen: true,
    frameBorder: "0"
  }))));
};

/* harmony default export */ __webpack_exports__["a"] = (OdaStudioModal);

/***/ }),

/***/ "Vi0R":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselIndicator":"_2bHezb","indicator":"_3D9BVU","active":"_8x-3tV"};

/***/ }),

/***/ "YIkO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pVnL"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("lSNA"));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__("RIqP"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("lwsE"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("a1gu"));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__("Nsbk"));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__("PJYZ"));

var _createClass2 = _interopRequireDefault(__webpack_require__("W8MJ"));

var _inherits2 = _interopRequireDefault(__webpack_require__("7W2i"));

var _propTypes = _interopRequireDefault(__webpack_require__("17x9"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _classnames = _interopRequireDefault(__webpack_require__("TSYQ"));

var _throttle = _interopRequireDefault(__webpack_require__("Fxm3"));

function isEqualArray(a, b) {
  return a.length === b.length && a.every(function (item, index) {
    return item === b[index];
  });
}

var Scrollspy =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Scrollspy, _React$Component);
  (0, _createClass2.default)(Scrollspy, null, [{
    key: "propTypes",
    get: function get() {
      return {
        items: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
        currentClassName: _propTypes.default.string.isRequired,
        scrolledPastClassName: _propTypes.default.string,
        style: _propTypes.default.object,
        componentTag: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
        offset: _propTypes.default.number,
        rootEl: _propTypes.default.string,
        onUpdate: _propTypes.default.func
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        items: [],
        currentClassName: '',
        style: {},
        componentTag: 'ul',
        offset: 0,
        onUpdate: function onUpdate() {}
      };
    }
  }]);

  function Scrollspy(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Scrollspy);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Scrollspy).call(this, props));
    _this.state = {
      targetItems: [],
      inViewState: [],
      isScrolledPast: [] // manually bind as ES6 does not apply this
      // auto binding as React.createClass does

    };
    _this._handleSpy = _this._handleSpy.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Scrollspy, [{
    key: "_initSpyTarget",
    value: function _initSpyTarget(items) {
      var targetItems = items.map(function (item) {
        return document.getElementById(item);
      });
      return targetItems;
    } // https://github.com/makotot/react-scrollspy/pull/45

  }, {
    key: "_fillArray",
    value: function _fillArray(array, val) {
      var newArray = [];

      for (var i = 0, max = array.length; i < max; i++) {
        newArray[i] = val;
      }

      return newArray;
    }
  }, {
    key: "_isScrolled",
    value: function _isScrolled() {
      return this._getScrollDimension().scrollTop > 0;
    }
  }, {
    key: "_getScrollDimension",
    value: function _getScrollDimension() {
      var doc = document;
      var rootEl = this.props.rootEl;
      var scrollTop = rootEl ? doc.querySelector(rootEl).scrollTop : doc.documentElement.scrollTop || doc.body.parentNode.scrollTop || doc.body.scrollTop;
      var scrollHeight = rootEl ? doc.querySelector(rootEl).scrollHeight : doc.documentElement.scrollHeight || doc.body.parentNode.scrollHeight || doc.body.scrollHeight;
      return {
        scrollTop: scrollTop,
        scrollHeight: scrollHeight
      };
    }
  }, {
    key: "_getElemsViewState",
    value: function _getElemsViewState(targets) {
      var elemsInView = [];
      var elemsOutView = [];
      var viewStatusList = [];
      var targetItems = targets ? targets : this.state.targetItems;
      var hasInViewAlready = false;

      for (var i = 0, max = targetItems.length; i < max; i++) {
        var currentContent = targetItems[i];
        var isInView = hasInViewAlready ? false : this._isInView(currentContent);

        if (isInView) {
          hasInViewAlready = true;
          elemsInView.push(currentContent);
        } else {
          elemsOutView.push(currentContent);
        }

        var isLastItem = i === max - 1;

        var isScrolled = this._isScrolled(); // https://github.com/makotot/react-scrollspy/pull/26#issue-167413769


        var isLastShortItemAtBottom = this._isAtBottom() && this._isInView(currentContent) && !isInView && isLastItem && isScrolled;

        if (isLastShortItemAtBottom) {
          elemsOutView.pop();
          elemsOutView.push.apply(elemsOutView, (0, _toConsumableArray2.default)(elemsInView));
          elemsInView = [currentContent];
          viewStatusList = this._fillArray(viewStatusList, false);
          isInView = true;
        }

        viewStatusList.push(isInView);
      }

      return {
        inView: elemsInView,
        outView: elemsOutView,
        viewStatusList: viewStatusList,
        scrolledPast: this.props.scrolledPastClassName && this._getScrolledPast(viewStatusList)
      };
    }
  }, {
    key: "_isInView",
    value: function _isInView(el) {
      if (!el) {
        return false;
      }

      var _this$props = this.props,
          rootEl = _this$props.rootEl,
          offset = _this$props.offset;
      var rootRect;

      if (rootEl) {
        rootRect = document.querySelector(rootEl).getBoundingClientRect();
      }

      var rect = el.getBoundingClientRect();
      var winH = rootEl ? rootRect.height : window.innerHeight;

      var _this$_getScrollDimen = this._getScrollDimension(),
          scrollTop = _this$_getScrollDimen.scrollTop;

      var scrollBottom = scrollTop + winH;
      var elTop = rootEl ? rect.top + scrollTop - rootRect.top + offset : rect.top + scrollTop + offset;
      var elBottom = elTop + el.offsetHeight;
      return elTop < scrollBottom && elBottom > scrollTop;
    }
  }, {
    key: "_isAtBottom",
    value: function _isAtBottom() {
      var rootEl = this.props.rootEl;

      var _this$_getScrollDimen2 = this._getScrollDimension(),
          scrollTop = _this$_getScrollDimen2.scrollTop,
          scrollHeight = _this$_getScrollDimen2.scrollHeight;

      var winH = rootEl ? document.querySelector(rootEl).getBoundingClientRect().height : window.innerHeight;
      var scrolledToBottom = scrollTop + winH >= scrollHeight;
      return scrolledToBottom;
    }
  }, {
    key: "_getScrolledPast",
    value: function _getScrolledPast(viewStatusList) {
      if (!viewStatusList.some(function (item) {
        return item;
      })) {
        return viewStatusList;
      }

      var hasFoundInView = false;
      var scrolledPastItems = viewStatusList.map(function (item) {
        if (item && !hasFoundInView) {
          hasFoundInView = true;
          return false;
        }

        return !hasFoundInView;
      });
      return scrolledPastItems;
    }
  }, {
    key: "_spy",
    value: function _spy(targets) {
      var _this2 = this;

      var elemensViewState = this._getElemsViewState(targets);

      var currentStatuses = this.state.inViewState;
      this.setState({
        inViewState: elemensViewState.viewStatusList,
        isScrolledPast: elemensViewState.scrolledPast
      }, function () {
        _this2._update(currentStatuses);
      });
    }
  }, {
    key: "_update",
    value: function _update(prevStatuses) {
      if (isEqualArray(this.state.inViewState, prevStatuses)) {
        return;
      }

      this.props.onUpdate(this.state.targetItems[this.state.inViewState.indexOf(true)]);
    }
  }, {
    key: "_handleSpy",
    value: function _handleSpy() {
      (0, _throttle.default)(this._spy(), 100);
    }
  }, {
    key: "_initFromProps",
    value: function _initFromProps() {
      var targetItems = this._initSpyTarget(this.props.items);

      this.setState({
        targetItems: targetItems
      });

      this._spy(targetItems);
    }
  }, {
    key: "offEvent",
    value: function offEvent() {
      var el = this.props.rootEl ? document.querySelector(this.props.rootEl) : window;
      el.removeEventListener('scroll', this._handleSpy);
    }
  }, {
    key: "onEvent",
    value: function onEvent() {
      var el = this.props.rootEl ? document.querySelector(this.props.rootEl) : window;
      el.addEventListener('scroll', this._handleSpy);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._initFromProps();

      this.onEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.offEvent();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      this._initFromProps();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var Tag = this.props.componentTag;
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          scrolledPastClassName = _this$props2.scrolledPastClassName,
          style = _this$props2.style;
      var counter = 0;

      var items = _react.default.Children.map(children, function (child, idx) {
        var _classNames;

        if (!child) {
          return null;
        }

        var ChildTag = child.type;
        var isScrolledPast = scrolledPastClassName && _this3.state.isScrolledPast[idx];
        var childClass = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(child.props.className), child.props.className), (0, _defineProperty2.default)(_classNames, "".concat(_this3.props.currentClassName), _this3.state.inViewState[idx]), (0, _defineProperty2.default)(_classNames, "".concat(_this3.props.scrolledPastClassName), isScrolledPast), _classNames));
        return _react.default.createElement(ChildTag, (0, _extends2.default)({}, child.props, {
          className: childClass,
          key: counter++
        }), child.props.children);
      });

      var itemClass = (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(className), className));
      return _react.default.createElement(Tag, {
        className: itemClass,
        style: style
      }, items);
    }
  }]);
  return Scrollspy;
}(_react.default.Component);

exports.default = Scrollspy;

/***/ }),

/***/ "ayqK":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"_1CRoz-","prevContainer":"PwHL2k","nextContainer":"_3atvi2"};

/***/ }),

/***/ "baKm":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"_2PFRqO"};

/***/ }),

/***/ "bigh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _desktop_oda_studio_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCP0");
/* harmony import */ var _helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("tkT3");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TyMc");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var OdaStudioFullScreen = function OdaStudioFullScreen(_ref) {
  var decorator = _ref.decorator;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      openIframe = _useState[0],
      setIsOpenIframe = _useState[1];

  var onClickIframe = function onClickIframe() {
    setIsOpenIframe(!openIframe);
    !openIframe && Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_2__[/* formGTMEventGA4 */ "o"])({
      eventName: 'evini_tasarla',
      eventParameters: {
        label: 'view-popup-odastudio-galeri'
      }
    });
  };

  return __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.container
  }, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.odaStudioWrapper,
    onClick: onClickIframe
  }, __jsx("img", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.odaStudioWrapperIcon,
    src: "/static/icons/oda-studio-web.svg",
    alt: "oda-studio-web.svg"
  }), __jsx("span", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.odaStudioWrapperText
  }, "Bu evi senin i\xE7in yapay zeka ile dekore ettik."), __jsx("span", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.odaStudioWrapperReviewText
  }, "Hemen \u0130ncele")), __jsx("div", null, __jsx(_desktop_oda_studio_modal__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
    boardUrl: decorator === null || decorator === void 0 ? void 0 : decorator.boardUrl,
    openIframe: openIframe,
    onClickIframe: onClickIframe
  })));
};

/* unused harmony default export */ var _unused_webpack_default_export = (OdaStudioFullScreen);

/***/ }),

/***/ "p1eE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GtmDataLayer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_google_tag_manager_handleGA4UndefinedValues__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9oOR");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var GtmDataLayer = function GtmDataLayer(_ref) {
  var ga4DataLayerListing = _ref.ga4DataLayerListing;
  var formattedDataLayer = Object(_helpers_google_tag_manager_handleGA4UndefinedValues__WEBPACK_IMPORTED_MODULE_2__[/* handleGA4UndefinedValues */ "a"])(ga4DataLayerListing);

  var dataLayerObject = _objectSpread(_objectSpread({
    platform: 'web-desktop'
  }, formattedDataLayer), {}, {
    design_type: 'old'
  });

  return __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx("script", {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: "dataLayer.push(".concat(JSON.stringify(dataLayerObject), ");")
    }
  }));
};

/***/ }),

/***/ "pxhf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"thumbnailsContainer":"_2LiRsw","fullScreenThumbnailsContainer":"SBwMM9","thumbnailsContent":"uqB4MK","thumbnailsImage":"_17ksCd","active":"_1Zcadk","fullscreenImage":"_3rdbkr"};

/***/ }),

/***/ "qLro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _desktop_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9aJQ");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("baKm");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var FullScreenButton = function FullScreenButton(_ref) {
  var onClick = _ref.onClick;
  return __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.button,
    onClick: onClick,
    "data-ej-category": "detailpage",
    "data-ej-action": "photobox",
    "data-ej-label": "link_expand"
  }, __jsx(_desktop_elements__WEBPACK_IMPORTED_MODULE_1__[/* Icon */ "e"], {
    name: "fullscreen",
    "data-ej-category": "detailpage",
    "data-ej-action": "photobox",
    "data-ej-label": "link_expand"
  }), __jsx("span", {
    "data-ej-category": "detailpage",
    "data-ej-action": "photobox",
    "data-ej-label": "link_expand"
  }, "B\xFCy\xFCt"));
};

/* harmony default export */ __webpack_exports__["a"] = (FullScreenButton);

/***/ }),

/***/ "tV6b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"showIndex":"_1lrDB5"};

/***/ }),

/***/ "tskV":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"_3OoP4V","h1":"RUQHKU"};

/***/ }),

/***/ "xhFV":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"prevContainer":"nRKd74","nextContainer":"_2eE-vS"};

/***/ }),

/***/ "yCkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/e6t/lazy-image/index.jsx
var lazy_image = __webpack_require__("eM4/");

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/thumbnails-arrow/styles.module.scss
var styles_module = __webpack_require__("9Rzt");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/thumbnails-arrow/index.jsx

var __jsx = react_default.a.createElement;





var thumbnails_arrow_ThumbnailArrow = function ThumbnailArrow(_ref) {
  var _classNames;

  var prev = _ref.prev,
      next = _ref.next,
      onClick = _ref.onClick,
      fullscreen = _ref.fullscreen;
  var thumbnailsClass = classnames_default()((_classNames = {}, Object(defineProperty["default"])(_classNames, styles_module_default.a.arrow, true), Object(defineProperty["default"])(_classNames, styles_module_default.a.prev, prev), Object(defineProperty["default"])(_classNames, styles_module_default.a.next, next), Object(defineProperty["default"])(_classNames, styles_module_default.a.fullscreen, fullscreen), _classNames));
  var iconName = prev ? 'arrow_back' : 'arrow_forward';
  var dataLabel = prev ? 'link_verticalscrollleft' : 'link_verticalscrollright';
  var dataAction = fullscreen ? 'expandedphoto' : 'photobox';
  return __jsx("div", {
    className: thumbnailsClass,
    onClick: onClick,
    "data-ej-category": "detailpage",
    "data-ej-action": dataAction,
    "data-ej-label": dataLabel
  }, __jsx(desktop_elements["e" /* Icon */], {
    name: iconName,
    "data-ej-category": "detailpage",
    "data-ej-action": dataAction,
    "data-ej-label": dataLabel
  }));
};

/* harmony default export */ var thumbnails_arrow = (thumbnails_arrow_ThumbnailArrow);
// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/carousel-indicator/styles.module.scss
var carousel_indicator_styles_module = __webpack_require__("Vi0R");
var carousel_indicator_styles_module_default = /*#__PURE__*/__webpack_require__.n(carousel_indicator_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/carousel-indicator/index.jsx

var carousel_indicator_jsx = react_default.a.createElement;




var carousel_indicator_Indicator = function Indicator(_ref) {
  var thumbnails = _ref.thumbnails,
      activeIndicator = _ref.activeIndicator,
      indicatorCount = _ref.indicatorCount;
  var indicator = thumbnails.slice(0, indicatorCount);

  var renderIndicator = function renderIndicator() {
    return indicator.map(function (item, index) {
      var _classNames;

      var indicatorStyles = classnames_default()((_classNames = {}, Object(defineProperty["default"])(_classNames, carousel_indicator_styles_module_default.a.indicator, true), Object(defineProperty["default"])(_classNames, carousel_indicator_styles_module_default.a.active, activeIndicator === index), _classNames));
      return carousel_indicator_jsx("a", {
        key: item
      }, carousel_indicator_jsx("div", {
        className: indicatorStyles
      }));
    });
  };

  return carousel_indicator_jsx("div", {
    style: {
      backgroundImage: 'url(/static/icons/shape-pagenation.png)',
      backgroundRepeat: 'no-repeat'
    },
    className: carousel_indicator_styles_module_default.a.carouselIndicator
  }, renderIndicator());
};

/* harmony default export */ var carousel_indicator = (carousel_indicator_Indicator);
// EXTERNAL MODULE: ./src/components/e6t/image-carousel/components/thumbnails-container/styles.module.scss
var thumbnails_container_styles_module = __webpack_require__("pxhf");
var thumbnails_container_styles_module_default = /*#__PURE__*/__webpack_require__.n(thumbnails_container_styles_module);

// CONCATENATED MODULE: ./src/components/e6t/image-carousel/components/thumbnails-container/index.jsx


var _this = undefined;

var thumbnails_container_jsx = react_default.a.createElement;







var thumbnails_container_ThumbnailsContainer = function ThumbnailsContainer(_ref) {
  var _classNames;

  var thumbnails = _ref.thumbnails,
      currentIndex = _ref.currentIndex,
      changeCurrentIndex = _ref.changeCurrentIndex,
      activeIndicator = _ref.activeIndicator,
      indicatorCount = _ref.indicatorCount,
      thumbnailsRef = _ref.thumbnailsRef,
      fullscreen = _ref.fullscreen,
      thumbnailsScrollLeft = _ref.thumbnailsScrollLeft,
      thumbnailsScrollRight = _ref.thumbnailsScrollRight;
  var containerStyles = classnames_default()((_classNames = {}, Object(defineProperty["default"])(_classNames, thumbnails_container_styles_module_default.a.thumbnailsContainer, true), Object(defineProperty["default"])(_classNames, thumbnails_container_styles_module_default.a.fullScreenThumbnailsContainer, fullscreen), _classNames));
  var dataAction = fullscreen ? 'expandedphoto' : 'photobox';

  var renderThumbnailsImage = function renderThumbnailsImage() {
    return thumbnails.map(function (image, index) {
      var _classNames2;

      var thumbnailsStyles = classnames_default()((_classNames2 = {}, Object(defineProperty["default"])(_classNames2, thumbnails_container_styles_module_default.a.active, currentIndex === index), Object(defineProperty["default"])(_classNames2, thumbnails_container_styles_module_default.a.thumbnailsImage, true), Object(defineProperty["default"])(_classNames2, thumbnails_container_styles_module_default.a.fullscreenImage, fullscreen), _classNames2));
      return thumbnails_container_jsx("div", {
        // ref={currentIndex === index ? activeThumbImageRef : null}
        className: thumbnailsStyles,
        key: image,
        onClick: changeCurrentIndex.bind(_this, index),
        "data-index": index,
        "data-ej-category": "detailpage",
        "data-ej-action": dataAction,
        "data-ej-label": "link_anyphoto"
      }, thumbnails_container_jsx(lazy_image["a" /* default */], {
        src: image,
        alt: image,
        "data-ej-category": "detailpage",
        "data-ej-action": dataAction,
        "data-ej-label": "link_".concat(index),
        placeholder: "/static/img/1px-transparent.png"
      }));
    });
  };

  return thumbnails_container_jsx("div", {
    className: containerStyles
  }, thumbnails_container_jsx(thumbnails_arrow, {
    prev: true,
    onClick: thumbnailsScrollLeft.bind(_this, activeIndicator),
    fullscreen: fullscreen
  }), thumbnails_container_jsx("div", {
    ref: thumbnailsRef,
    className: thumbnails_container_styles_module_default.a.thumbnailsContent,
    "data-ej-category": "detailpage",
    "data-ej-action": dataAction,
    "data-ej-label": "link_anyphoto"
  }, renderThumbnailsImage()), thumbnails_container_jsx(thumbnails_arrow, {
    next: true,
    onClick: thumbnailsScrollRight.bind(_this, activeIndicator),
    fullscreen: fullscreen
  }), thumbnails_container_jsx(carousel_indicator, {
    thumbnails: thumbnails,
    activeIndicator: activeIndicator,
    indicatorCount: indicatorCount
  }));
};

/* harmony default export */ var thumbnails_container = __webpack_exports__["a"] = (thumbnails_container_ThumbnailsContainer);

/***/ })

}]);